import React from "react";
import { Card } from "react-bootstrap";
import { Factory, Building, Laptop } from "lucide-react";
import "./Sectors.css";
import Footer from "./Footer";
import NavBar from "./NavBar"

const sectors = [
  {
    icon: Factory,
    title: "Primary Sector",
    items: ["Agriculture & Agribusiness", "Mining & Extractives", "Energy & Power", "Natural Resources"],
    color: "#16a34a", // green
    bg: "rgba(22, 163, 74, 0.1)",
  },
  {
    icon: Building,
    title: "Secondary Sector",
    items: ["Manufacturing", "Construction", "Processing Industries", "Infrastructure Development"],
    color: "#2563eb", // blue
    bg: "rgba(37, 99, 235, 0.1)",
  },
  {
    icon: Laptop,
    title: "Tertiary Sector",
    items: ["Technology & Innovation", "Financial Services", "Healthcare", "Education & Training", "Retail & Distribution"],
    color: "#1e90ff", // accent
    bg: "rgba(30, 144, 255, 0.1)",
  },
];

const Sectors = () => {
  return (
    <section id="sectors">
      <NavBar />
      <div className="sectors-section">
        <div className="container text-center">
          <h2 className="display-3 fw-bold66 mb-3">
            Engagement <span className="the-color">Sectors</span>
          </h2>
          <p className="section-subtitle mb-5">
            Comprehensive expertise across all major economic sectors in Africa
          </p>

          <div className="sectors-grid">
            {sectors.map((sector, index) => (
              <Card key={index} className="sector-card">
                <div className="icon-wrapper" style={{ backgroundColor: "rgba(240, 180, 41, 0.1)" }}>
                  <sector.icon className="sector-icon" style={{ color: "#6d492d" }} />
                </div>
                <div className="sector-content">
                  <h4 className="fw-bold">{sector.title}</h4>
                  <ul>
                    {sector.items.map((item, idx) => (
                      <li key={idx}>
                        <span className="bullet" style={{ color: sector.color }}>•</span>
                        <span className="item-text">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </section>
  );
};

export default Sectors;
